/* eslint-disable no-undef */
import React from 'react';
import userDetail from 'Stores/userDetail';
import { observer } from 'mobx-react';
import DomainSearch from './domainSearch/domainSearch';
import SavedSearch from './savedSearch/savedSearch';
import MyLeadList from './myLeadList/myLeadList';
// import './_dashboard.scss';

const Dashboard = observer(() => {
  React.useEffect(() => {
    const ele = document.getElementById('dashboardSearchBox');
    if (document.getElementById('dashboardSearchBox') !== undefined)
      document.getElementById('dashboardSearchBox').focus();
  }, []);

  return (
    <div className="dashboard-layout">
      <DomainSearch />
      <div className="container">
        {(userDetail.myLeadList.length > 0 ||
          userDetail.contactSavedSearches.length > 0) && (
          <div className="row">
            <div className="col-12 col-sm-6 saved-search">
              <SavedSearch />
            </div>
            <div className="col-12 col-sm-6 my-lead-list">
              <MyLeadList />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default Dashboard;
